import React, { useEffect, useState } from "react";
import "../style/CoinPriceTable.css";

export default function CoinPriceTable() {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);

  // Справочник для визуализации (логотипы и цвета)
  const coinData = {
    BTC: { name: "Bitcoin", icon: "₿", color: "#F7931A" },
    ETH: { name: "Ethereum", icon: "Ξ", color: "#627EEA" },
    SOL: { name: "Solana", icon: "◎", color: "#14F195" },
    ADA: { name: "Cardano", icon: "◆", color: "#0033AD" },
    DOGE: { name: "Dogecoin", icon: "🐕", color: "#BA9F33" },
    LINK: { name: "Chainlink", icon: "⛓", color: "#375BD2" },
    AVAX: { name: "Avalanche", icon: "▲", color: "#E84142" },
  };

const fetchData = async () => {
  try {
    const res = await fetch("https://bilpay.kg/api/coins"); // Проверьте порт своего сервера
    const json = await res.json();

    // ПРОВЕРКА: Если бэкенд вернул { success: true, data: { BTC: [...], ETH: [...] } }
    if (json.success && json.data) {
      const coinsArray = Object.entries(json.data).map(([symbol, history], index) => {
        // Берем последнюю точку из массива истории монеты
        const lastPrice = history[history.length - 1]?.rate || 0;
        const firstPrice = history[0]?.rate || lastPrice;
        
        const percentChange = firstPrice !== 0 
          ? ((lastPrice - firstPrice) / firstPrice) * 100 
          : 0;

        return {
          rank: index + 1,
          symbol,
          name: coinData[symbol]?.name || symbol,
          icon: coinData[symbol]?.icon || "•",
          iconColor: coinData[symbol]?.color || "#42b693",
          price: lastPrice,
          percentChange: parseFloat(percentChange.toFixed(2)),
        };
      });

      setCoins(coinsArray);
    }
    setLoading(false);
  } catch (err) {
    console.error("Error fetching coin data:", err);
    setLoading(false);
  }
};

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000); // Обновление каждые 30 сек
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div className="loader">Загрузка котировок...</div>;

  return (
 <div className="crypto-section-container">
  <div className="crypto-section">
    <div className="table-header-flex">
      <h2 className="table-main-title">Рынок криптовалют</h2>
      <span className="live-indicator">LIVE</span>
    </div>

    <div className="custom-table-wrapper">
      <table className="modern-table">
        <thead>
          <tr>
            <th className="hide-mobile">#</th>
            <th>Активы</th>
            <th>Изменение</th>
            <th className="text-right">Цена</th>
          </tr>
        </thead>
        <tbody>
          {coins.map((coin) => (
            <tr key={coin.symbol} className="table-row-animate">
              <td className="td-rank hide-mobile">{coin.rank}</td>
              <td className="td-coin">
                <div className="coin-flex">
                  <div className="coin-avatar" style={{ background: coin.iconColor }}>
                    {coin.icon}
                  </div>
                  <div className="coin-info">
                    <span className="coin-full-name">{coin.name}</span>
                    <span className="coin-ticker">{coin.symbol}</span>
                  </div>
                </div>
              </td>
              <td className="td-change">
                <span className={`badge ${coin.percentChange >= 0 ? "up" : "down"}`}>
                  {coin.percentChange >= 0 ? "▲" : "▼"} {Math.abs(coin.percentChange)}%
                </span>
              </td>
              <td className="td-price text-right">
                ${coin.price.toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="source-tag">Данные обновляются в реальном времени • CoinStats API</p>
  </div>
</div>
  );
}